module.exports = __webpack_public_path__ + "img/AT0000203159106.fc0851a6.png";